import { Search, SlidersHorizontal } from 'lucide-react';

interface InventoryFilterBarProps {
  selectedType: string;
  setSelectedType: (value: string) => void;
  selectedBrand: string;
  setSelectedBrand: (value: string) => void;
  selectedModel: string;
  setSelectedModel: (value: string) => void;
  brands: string[];
  models: string[];
  filteredCount: number;
  hasAdvancedFilters: boolean;
  hasFilters: boolean;
  buttonColor: string;
  onOpenMoreFilters: () => void;
  onClear: () => void;
  onSearch: () => void;
}

const TYPE_OPTIONS = [
  { value: 'all', label: 'Todos os tipos' },
  { value: 'zerokm', label: 'Zero KM' },
  { value: 'seminovo', label: 'Seminovos' },
];

export function InventoryFilterBar({
  selectedType,
  setSelectedType,
  selectedBrand,
  setSelectedBrand,
  selectedModel,
  setSelectedModel,
  brands,
  models,
  filteredCount,
  hasAdvancedFilters,
  hasFilters,
  buttonColor,
  onOpenMoreFilters,
  onClear,
  onSearch,
}: InventoryFilterBarProps) {
  const handleBrandChange = (value: string) => {
    setSelectedBrand(value);
    setSelectedModel('all');
  };

  return (
    <div className="wl6-inv-filter-bar">
      <div className="wl6-inv-filter-bar__fields">
        <div className="wl6-inv-filter-bar__field">
          <span className="wl6-inv-filter-bar__label">Tipo</span>
          <select
            className="wl6-inv-filter-bar__select"
            value={selectedType}
            onChange={(e) => setSelectedType(e.target.value)}
            aria-label="Tipo de veículo"
          >
            {TYPE_OPTIONS.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>

        <div className="wl6-inv-filter-bar__field">
          <span className="wl6-inv-filter-bar__label">Marca</span>
          <select
            className="wl6-inv-filter-bar__select"
            value={selectedBrand}
            onChange={(e) => handleBrandChange(e.target.value)}
            aria-label="Marca"
          >
            <option value="all">Todas as marcas</option>
            {brands.map((brand) => (
              <option key={brand} value={brand}>
                {brand}
              </option>
            ))}
          </select>
        </div>

        <div className="wl6-inv-filter-bar__field">
          <span className="wl6-inv-filter-bar__label">Modelo</span>
          <select
            className="wl6-inv-filter-bar__select"
            value={selectedModel}
            onChange={(e) => setSelectedModel(e.target.value)}
            disabled={selectedBrand === 'all'}
            aria-label="Modelo"
          >
            <option value="all">Todos os modelos</option>
            {models.map((model) => (
              <option key={model} value={model}>
                {model}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="wl6-inv-filter-bar__actions">
        <button
          type="button"
          className="wl6-inv-filter-bar__more"
          onClick={onOpenMoreFilters}
          aria-label="Mais filtros"
        >
          <SlidersHorizontal className="h-4 w-4 shrink-0" />
          Mais filtros
          {hasAdvancedFilters && (
            <span className="wl6-inv-filter-bar__more-badge" aria-hidden />
          )}
        </button>

        <div className="wl6-inv-filter-bar__actions-end">
          <button
            type="button"
            className="wl6-inv-filter-bar__clear"
            onClick={onClear}
            disabled={!hasFilters}
          >
            Limpar
          </button>

          <button
            type="button"
            className="wl6-inv-filter-bar__search"
            style={{ backgroundColor: buttonColor }}
            onClick={onSearch}
            aria-label={`Buscar ${filteredCount} veículos`}
          >
            <Search className="h-4 w-4 shrink-0" />
            Buscar
          </button>
        </div>
      </div>
    </div>
  );
}
